export default function ErrorMessage({errorMsg}) {

  if (errorMsg) {
    return (
      <div style={{fontWeight: 500, color: 'darkred', textAlign: "center", paddingTop: '20px', paddingBottom: '20px'}}>
        {errorMsg}
      </div>
    )
  } else {
    return null
  }
}
